/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React from 'react';
import { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IconContext } from 'react-icons';
import {
  FaEdit,
  FaInfoCircle,
  FaMapMarkedAlt,
  FaQuestionCircle,
  FaSignal,
  FaTrashAlt,
  FaUserCog,
} from 'react-icons/fa';
import { CgMenuGridR } from 'react-icons/cg';
import { FiAlertTriangle, FiArrowLeftCircle, FiSettings } from 'react-icons/fi';
import { GiNightSleep } from 'react-icons/gi';
import { HiRefresh } from 'react-icons/hi';
import { HiQueueList } from 'react-icons/hi2';
import { useSelector } from 'react-redux';
import ModalGenerico from '../../../home/Modal_generico';
import EditModal from '../../modals/EditModal';
import Select from 'react-select';
import { useEffect } from 'react';
import scaleDecimal from '../../../../support_func/scaleDecimal';
import ConfigModal from '../../modals/ConfigModal';
import Permissions from '../../menuViews/all/Permissions';
import Timer from '../../../../support_func/Timer';
import OrdersModal from '../../modals/OrdersModal';
import SensorVisualIcon from '../SensorVisualIcon';

const SensorsControl = (props) => {
  const { t } = useTranslation();

  const idri = useSelector((state) => state.idri);
  const markers = useSelector((state) => state.markers);  

  const communicationTechnology =
    idri.com_tech !== undefined &&
    idri.com_tech !== null &&
    idri.net_tech_options
      ? idri.net_tech_options.find(
          (option) => option.code === idri.com_tech
        )?.tech || idri.com_tech
      : null;

  const formattedLastReading = idri.last_read_date
    ? `${moment(idri.last_read_date).format('L')} ${moment(
        idri.last_read_date
      ).format('LTS')}`
    : t('noDisponible');

  const [edited, setEdited] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [ordersModal, setOrdersModal] = useState(false);
  const [permissionsModal, setPermissionsModal] = useState(false);
  const [configModal, setConfigModal] = useState(false);
  const [autoUseDis, setAutoUseDis] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [idriStatus, setIdriStatus] = useState({});
  const [list, setList] = useState([]);
  const [key, setKey] = useState(0);

  const getIdriId = (serial, ret) => {
    return Object.entries(markers).map(([key, value]) => {
      // eslint-disable-next-line eqeqeq
      if (serial == value.ghatorserial) {
        if (ret) {
          return value.ghatorid;
        }
        props.getIdri(false, value.ghatorserial, value.ghatorid);
      }
    });
  };

  const editCloseHandler = () => {
    if (edited) {
      if (window.confirm(t('datosEliminados'))) {
        setEditModal(false);
        props.getIdri(null, idri.ghatorserial, idri.ghatorid);
        setEdited(false);
      }
    } else {
      setEditModal(false);
    }
  };

  useEffect(() => {
    if (markers && Object.keys(markers).length > 0) {
      const newList = Object.entries(markers).map(([key, value]) => ({
        value: value.ghatorserial,
        label: `${value.ghatorname} (${value.ghatorserial}${
          value.v_firmware ? `/${value.v_firmware}` : ''
        })`,
        name: value.ghatorname,
        serial: value.ghatorserial,
        firmware: value.v_firmware,
        isDisabled:
          localStorage.getItem('profile') !== 'admi' && !value.discharged,
      }));

      setList(newList);
    }
  }, [markers]);

  useEffect(() => {
    props.setAutoUse(idri.master_en);
    let arr = [];
    let slaves = [];
    idri.actuators &&
      idri.actuators.map((actuador) => {
        slaves = slaves.concat(actuador.slaves);
      });

    idri.actuators.map((actuador) => {
      if (actuador.status === 1 && slaves.includes(actuador.idactuator)) {
        arr.push(true);
      }
    });
    arr.length > 0 ? setAutoUseDis(true) : setAutoUseDis(false);

    const listObj = list.find(
      (item) => item.value === idri.ghatorserial
    );

    if (listObj) {
      listObj.label = `${idri.ghatorname} (${idri.ghatorserial}${
        idri.v_firmware ? ` - f${idri.v_firmware}` : ''
      })`;

      listObj.name = idri.ghatorname;
      listObj.serial = idri.ghatorserial;
      listObj.firmware = idri.v_firmware;

      setList([...list]);
      setKey((prevKey) => prevKey + 1);
    }
  }, [idri]);

  
  const myTooltip = (
    <Tooltip className='p-2 text'>
      {parseInt(
        Math.abs(
          moment.duration(moment()).asMinutes() -
            moment.duration(moment(idri.last_read_date)).asMinutes()
        ) / idri.tsleep
      ) > 0 && (
        <Row className='p-2'>
          <Col>
            {t('connectionsFailed')}:{' '}
            {parseInt(
              Math.abs(
                moment.duration(moment()).asMinutes() -
                  moment.duration(moment(idri.last_read_date)).asMinutes()
              ) / idri.tsleep
            )}
          </Col>
        </Row>
      )}
      <Row className='p-2'>
        {t('nextConnection')}:
        <Timer
          min={
            moment.duration(moment()).asMinutes() -
              moment.duration(moment(idri.last_read_date)).asMinutes() >
            idri.tsleep
              ? idri.tsleep -
                (Math.abs(
                  moment.duration(moment()).asMinutes() -
                    moment.duration(moment(idri.last_read_date)).asMinutes()
                ) %
                  idri.tsleep)
              : idri.tsleep -
                (moment.duration(moment()).asMinutes() -
                  moment.duration(moment(idri.last_read_date)).asMinutes())
          }
          sec={0}
        />
      </Row>
    </Tooltip>
  );

  const deviceInfoPopover = (
    <Popover id='ghator-device-info' className='ghator-info-popover text'>
      <Popover.Header as='h3' className='text-center'>
        {t('info')}
      </Popover.Header>

      <Popover.Body>
        <Row className='gy-1'>
          <Col xs={12} className='popover-label'>
            {t('nombre')}
          </Col>
          <Col xs={12} className='text-break small'>
            {idri.ghatorname || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            serial
          </Col>
          <Col xs={7} className='small'>
            {idri.ghatorserial || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            {t('firmware')}
          </Col>
          <Col xs={7} className='small'>
            {idri.v_firmware || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            pcb
          </Col>
          <Col xs={7} className='small'>
            {idri.ghatorv || '-'}
          </Col>

          <Col xs={12}>
            <hr className='my-1' />
          </Col>

          <Col xs={12} className='popover-label'>
            email
          </Col>
          <Col xs={12} className='text-break small'>
            {idri.owner?.email ? (
              <a
                target='_blank'
                href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${idri.owner.email}`}
                className='text-decoration-none'
                rel='noreferrer'
              >
                {idri.owner.email}
              </a>
            ) : (
              '-'
            )}
          </Col>

          <Col xs={5} className='popover-label'>
            sim
          </Col>
          <Col xs={7} className='text-break small'>
            {idri.sim?.simprovider || '-'}
          </Col>

          <Col xs={12} className='popover-label'>
            iccid
          </Col>
          <Col xs={12} className='text-break small'>
            {idri.sim?.iccid || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            ip
          </Col>
          <Col xs={7} className='text-break small'>
            {idri.sim?.ip || '-'}
          </Col>

          <Col xs={12}>
            <hr className='my-1' />
          </Col>

          <Col xs={5} className='popover-label'>
            {t('estado')}
          </Col>
          <Col xs={7} className='small'>
            {props.deviceStatus?.label || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            tech
          </Col>
          <Col xs={7} className='small'>
            {communicationTechnology || '-'}
          </Col>

          <Col xs={5} className='popover-label'>
            {t('signal')}
          </Col>
          <Col xs={7} className='small'>
            {idri.signal_quality !== null &&
            idri.signal_quality !== undefined
              ? `${idri.signal_quality}%`
              : '-'}
          </Col>

          <Col xs={12} className='popover-label'>
            {t('ultimaLectura')}
          </Col>
          <Col xs={12} className='small'>
            {formattedLastReading}
          </Col>
        </Row>
      </Popover.Body>
    </Popover>
  );

  const getSensorDisplayValue = (sensor) => {
    const kindCode = sensor.kind_sensor?.code;

    if (kindCode === 0 || kindCode === 4) {
      if (sensor.status === true) return t('activado');
      if (sensor.status === false) return t('desactivado');

      return t('noDisponible');
    }

    return sensor.value !== null && sensor.value !== undefined
      ? sensor.value
      : '0.0';
  };

  return (
    <Table bordered className='mb-0 test'>
      <thead>
        {props.page === 'idri' && list.length > 0 && (
          <>
            <tr className="border-0">
              <td className='border-0 px-1 pt-1 pb-0 text-end'>
                <span className='text-muted small'>
                  {props.profile === 'gamo' && t('misIdris')}
                  {props.profile === 'delg' && t('delegado')}
                  {props.profile === 'inst' && t('instalByMe')}
                  {props.profile === 'admi' && t('todos')}
                </span>
              </td>
            </tr>

            <tr>
              <td className='border-0 p-0 pb-2'>
                <Select
                  key={key}
                  menuShouldScrollIntoView
                  placeholder={t('selectIdris')}
                  defaultValue={list.filter(
                    (option) => option.value === idri.ghatorserial
                  )}
                  isSearchable={true}
                  isClearable={false}
                  maxMenuHeight={320}
                  options={list}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '42px',
                      borderRadius: '8px',
                      borderColor: state.isFocused ? '#0066cc' : '#ced4da',
                      boxShadow: state.isFocused
                        ? '0 0 0 0.2rem rgba(0, 102, 204, 0.15)'
                        : '0 2px 6px rgba(0, 0, 0, 0.06)',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                      transition:
                        'border-color 0.15s ease, box-shadow 0.15s ease',
                      '&:hover': {
                        borderColor: '#0066cc',
                      },
                    }),

                    valueContainer: (base) => ({
                      ...base,
                      padding: '4px 12px',
                    }),

                    singleValue: (base) => ({
                      ...base,
                      fontWeight: 500,
                      color: '#212529',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }),

                    placeholder: (base) => ({
                      ...base,
                      color: '#6c757d',
                    }),

                    dropdownIndicator: (base, state) => ({
                      ...base,
                      color: state.isFocused ? '#0066cc' : '#6c757d',
                      transition: 'transform 0.2s ease, color 0.15s ease',
                      transform: state.selectProps.menuIsOpen
                        ? 'rotate(180deg)'
                        : null,
                      '&:hover': {
                        color: '#0066cc',
                      },
                    }),

                    indicatorSeparator: () => ({
                      display: 'none',
                    }),

                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),

                    menu: (base) => ({
                      ...base,
                      marginTop: '4px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      zIndex: 9999,
                      boxShadow: '0 8px 22px rgba(0, 0, 0, 0.16)',
                    }),

                    menuList: (base) => ({
                      ...base,
                      padding: '4px',
                    }),

                    option: (base, { isFocused, isSelected, isDisabled }) => ({
                      ...base,
                      margin: '2px 0',
                      padding: '9px 12px',
                      borderRadius: '6px',
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      backgroundColor: isSelected
                        ? 'rgba(0, 102, 204, 0.12)'
                        : isFocused
                        ? 'rgba(0, 102, 204, 0.07)'
                        : '#fff',
                      color: isDisabled
                        ? '#adb5bd'
                        : isSelected
                        ? '#004c99'
                        : '#212529',
                      fontWeight: isSelected ? 600 : 400,
                      '&:active': {
                        backgroundColor: 'rgba(0, 102, 204, 0.16)',
                      },
                    }),

                    noOptionsMessage: (base) => ({
                      ...base,
                      color: '#6c757d',
                    }),
                  }}
                  onChange={(option) => {
                    getIdriId(option.value);
                    props.setControl('');

                    props.setData({
                      id: getIdriId(option.value, true).find((value) => value),
                      serial: option.value,
                    });
                  }}
                />
              </td>
            </tr>
          </>
        )}
        {/* <tr className='dark text-center '> */}
        <tr className='ghator-header text-center'>
          <th colSpan={2} className='lh-sm position-relative'>
            <>
              <div className='position-relative'>
                <OverlayTrigger
                  trigger={'click'}
                  rootClose
                  // rootCloseEvent='mousedown'
                  placement={'right'}
                  overlay={
                    <Popover>
                      <Popover.Body>
                        {/* <Row> */}
                        <IconContext.Provider value={{ size: '1.1em', color: 'dodgerblue' }}>
                          {parseFloat(idri.ghatorv) >= 3 && (
                            <>
                              <OverlayTrigger
                                placement='bottom'
                                // show={autoUseDis}
                                overlay={
                                  autoUseDis || idri.wkmode === 2 ? (
                                    <Tooltip show={autoUseDis || idri.wkmode === 2}>
                                      {autoUseDis
                                        ? t('noCambiarUsoAutomatico')
                                        : t('noChangeInSleep')}
                                    </Tooltip>
                                  ) : (
                                    <span></span>
                                  )
                                }
                              >
                                <Col xs={12} className='py-1 testSvg d-flex'>
                                  <Form.Check
                                    disabled={
                                      !idri.user_permissions.action ||
                                      autoUseDis ||
                                      idri.wkmode === 2
                                    }
                                    type='switch'
                                    id='autoUse'
                                    checked={props.autoUse}
                                    onChange={(e) => {
                                      props.setAutoUse(e.target.checked);
                                    }}
                                    onBlur={(e) =>
                                      e.target.checked !== idri.master_en &&
                                      props.masterEn(e, e.target.checked)
                                    }
                                  />
                                  <span className=''>
                                    {t('autoMaster').charAt(0).toUpperCase() +
                                      t('autoMaster').slice(1)}
                                  </span>
                                </Col>
                              </OverlayTrigger>
                              {/* )} */}
                            </>
                          )}

                          {localStorage.getItem('menu') !== 'newIdris' && (
                            <>
                              <Col xs={12} className='py-1 testSvg'>
                                <FiSettings
                                  type='button'
                                  className={`${
                                    !idri.user_permissions.edit && 'disabledCustom'
                                  } ms-1`}
                                  onClick={(e) => {
                                    if (idri.user_permissions.edit) {
                                      window.confirm(t('cambiosAfectaran')) && setConfigModal(true);
                                    }
                                  }}
                                />
                                <span className='ms-3'>{t('configDispositivo')}</span>
                              </Col>
                              <Col xs={12} className='py-1 testSvg'>
                                <FaEdit
                                  type='button'
                                  className={`${
                                    !idri.user_permissions.edit && 'disabledCustom'
                                  } ms-1`}
                                  onClick={(e) => {
                                    if (idri.user_permissions.edit) {
                                      setEditModal(true);
                                      document.getElementById('myCheck') &&
                                        document.getElementById('myCheck').click();
                                    }
                                  }}
                                />
                                <span className='ms-3'>{t('editRecursos')}</span>
                              </Col>
                              <Col xs={12} className='py-1 testSvg'>
                                <FaUserCog
                                  type='button'
                                  className={`${
                                    !idri.user_permissions.edit && 'disabledCustom'
                                  } ms-1`}
                                  onClick={(e) => {
                                    if (idri.user_permissions.edit) {
                                      setPermissionsModal(true);
                                      document.getElementById('myCheck') &&
                                        document.getElementById('myCheck').click();
                                    }
                                  }}
                                />
                                <span className='ms-3'>{t('editPermissions')}</span>
                              </Col>
                            </>
                          )}
                          {props.profiles && props.profiles.admi && (
                            <Col xs={12} className='py-1 testSvg'>
                              <FaTrashAlt
                                type='button'
                                color='red'
                                className='ms-1'
                                onClick={(e) =>
                                  window.confirm(t('delete')) ? setDeleteModal(true) : null
                                }
                              />
                              <span className='ms-3'>{t('eliminarIdri')}</span>
                            </Col>
                          )}
                          <Col xs={12} className='py-1 testSvg'>
                            <FaQuestionCircle type='button' className='ms-1' />{' '}
                            <span className='ms-2'>{t('ayuda')}</span>
                          </Col>
                        </IconContext.Provider>
                        {/* </Row> */}
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <Button
                    className='position-absolute top-0 start-0 p-0 additionalMenu white'
                    id='myCheck'
                  >
                    <IconContext.Provider
                      value={{
                        size: '1.6em',
                        color: 'black'
                      }}
                    >
                      <CgMenuGridR />
                    </IconContext.Provider>
                  </Button>
                </OverlayTrigger>
                <Modal
                  // size='sm'
                  show={deleteModal}
                  onHide={() => setDeleteModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('introducePassword')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form className='text-center' onSubmit={(e) => props.deleteIdri(e)}>
                      <Form.Control
                        required
                        minLength={8}
                        type='password'
                        autoComplete='off'
                        value={props.password}
                        onChange={(e) => props.setPassword(e.target.value)}
                      />
                      <Button variant='outline-danger' className='mt-3' size='sm' type='submit'>
                        {t('eliminarIdri')}
                      </Button>
                    </Form>
                  </Modal.Body>
                </Modal>
                <ModalGenerico
                  title={t('editPermissions')}
                  onClose={() => {
                    setPermissionsModal(false);
                    props.getIdri(null, idri.ghatorserial, idri.ghatorid);
                  }}
                  show={permissionsModal}
                >
                  <Permissions
                    ghatorid={idri.ghatorid}
                    ghatorserial={idri.ghatorserial}
                    ghatorname={idri.ghatorname}
                    closeModal={() => setPermissionsModal(false)}
                  />
                </ModalGenerico>
                <ModalGenerico
                  title={t('editRecursos')}
                  onClose={() => editCloseHandler()}
                  show={editModal}
                >
                  <EditModal
                    id={idri.ghatorid}
                    serial={idri.ghatorserial}
                    setEdited={setEdited}
                    getIdri={() => props.getIdri()}
                    refresh={() => props.refresh()}
                    closeModal={() => setEditModal(false)}
                  />
                </ModalGenerico>
                <ModalGenerico
                  title={t('configDispositivo') + ' ' + idri.ghatorserial}
                  // disabled={!idri.user_permissions.edit}
                  onClose={() => {
                    if (!idriStatus.inicialized) {
                      if (
                        window.confirm(
                          idri.wkmode !== 0 ? t('noInitRefresh') : t('noInitLostUsability')
                        )
                      ) {
                        setConfigModal(false);
                        props.getIdri(null, idri.ghatorserial, idri.ghatorid);
                      }
                    } else {
                      setConfigModal(false);
                      props.getIdri(null, idri.ghatorserial, idri.ghatorid);
                    }
                    // setConfigModal(false);
                    // props.getIdri(null, idri.idriserial, idri.ididri);
                  }}
                  show={configModal}
                >
                  {/* <EditModal
                    id={idri.ididri}
                    serial={idri.idriserial}
                    closeModal={() => setConfigModal(false)}
                  /> */}
                  {/* <IdriInit /> */}
                  <ConfigModal
                    id={idri.ghatorid}
                    serial={idri.ghatorserial}
                    v_idri={idri.ghatorv}
                    idriStatus={idriStatus}
                    setIdriStatus={setIdriStatus}
                    closeModal={() => {
                      setConfigModal(false);
                      props.getIdri(null, idri.ghatorserial, idri.idighatoriddri);
                    }}
                  />
                </ModalGenerico>
              </div>
              
              <OverlayTrigger
                trigger='click'
                rootClose
                placement='auto'
                overlay={deviceInfoPopover}
              >
                <Button
                  variant='link'
                  className='position-absolute top-0 end-0 p-1 text-white border-0'
                  aria-label={t('info')}
                >
                  <FaInfoCircle />
                </Button>
              </OverlayTrigger>
              <p className='fw-normal lh-sm my-0'>
                {t('ultimaLectura')}: {formattedLastReading}
              </p>
              <div
                className='mt-3 text-center'
                style={{ minHeight: '1.5rem' }}
              >
                {props.deviceStatus && (
                  //<div className='d-flex justify-content-center mt-3'>
                    <span
                      className='d-inline-flex align-items-center px-2 py-1 rounded-pill'
                      style={{
                        color: props.deviceStatus.color,
                        backgroundColor: props.deviceStatus.backgroundColor,
                        border: `1px solid ${props.deviceStatus.color}`,
                        fontSize: '0.72rem',
                        padding: '0.18rem 0.55rem',
                        fontWeight: 600,
                      }}
                    >
                      <span
                        className='rounded-circle me-1'
                        style={{
                          width: '0.45em',
                          height: '0.45em',
                          backgroundColor: props.deviceStatus.color,
                        }}
                      />

                      {props.deviceStatus.label}
                    </span>
                  //</div>
                )}
              </div>
              <Row className='position-absolute bottom-0 start-0 m-2 text-end'>
                <Col xs={12} className='p-0 m-0'>
                  {idri.wkmode !== 0 && (
                    <IconContext.Provider
                      value={{
                        attr: { fill: 'yellow' },
                        size: '1.5em',
                      }}
                    >
                      <OverlayTrigger
                        placement='auto'
                        rootClose='true'
                        trigger={'click'}
                        overlay={myTooltip}
                      >
                        <span>
                          <GiNightSleep className='p-0 m-0 me-md-2' />
                        </span>
                      </OverlayTrigger>
                    </IconContext.Provider>
                  )}
                </Col>
              </Row>
              <Row className='position-absolute bottom-0 end-0 m-2 text-end'>
                <Col xs="auto" className="p-0 m-0 position-relative">
                  {/* Etiqueta  tecnología comunicación usada - encima */}
                  {communicationTechnology && (
                    <span
                      className='position-absolute top-0 end-0 translate-middle-y'
                      style={{
                        fontSize: '0.60em',
                        fontWeight: '500',
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        color: idri.last_read_error ? '#888' : '#00ff95',
                        padding: '0 4px',
                        lineHeight: '1',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {communicationTechnology}
                    </span>
                  )}

                  {/* Barras de señal */}
                  {idri.signal_quality !== null &&
                    idri.signal_quality !== undefined && (
                    <>
                      <svg width='0' height='0'>
                        <defs>
                          <linearGradient id='myGradient'>
                            <stop
                              offset={
                                (idri.signal_quality > 0 && idri.signal_quality <= 20 && '20%') ||
                                (idri.signal_quality > 20 && idri.signal_quality <= 40 && '40%') ||
                                (idri.signal_quality > 40 && idri.signal_quality <= 60 && '60%') ||
                                (idri.signal_quality > 60 && idri.signal_quality <= 80 && '80%') ||
                                (idri.signal_quality > 80 && idri.signal_quality <= 100 && '100%')
                              }
                              stopColor={idri.last_read_error ? "gray" : "green"}
                            />
                            <stop offset='0%' stopColor='white' />
                          </linearGradient>
                        </defs>
                      </svg>
                      <IconContext.Provider
                        value={{
                          attr: { fill: "url('#myGradient')" },
                          size: '1.6em',
                        }}
                      >
                        <FaSignal className='p-0 m-0' />
                      </IconContext.Provider>
                    </>
                  )}
                </Col>
              </Row>
            </>
          </th>
        </tr>
        
      </thead>
      <tbody className='text-center'>
        <tr className="ghator-toolbar">
          <td className="ghator-toolbar__cell">
            <IconContext.Provider value={{ color: '#0066cc' }}>
              <Row className='justify-content-center'>
                {props.page === 'idri' && (
                  <OverlayTrigger
                    placement='top'
                    rootClose='true'
                    trigger={['hover', 'click', 'focus']}
                    overlay={<Tooltip>{t('dispositivos')}</Tooltip>}
                  >
                    <Col xs={1} className='p-0 mx-3 testSvg'>
                      <FaMapMarkedAlt type='button' onClick={() => props.setPage('map')} />
                    </Col>
                  </OverlayTrigger>
                )}
                {props.setFirstPage && (
                  <OverlayTrigger
                    placement='top'
                    rootClose='true'
                    trigger={['hover', 'click', 'focus']}
                    overlay={<Tooltip>{t('back')}</Tooltip>}
                  >
                    <Col xs={1} className='p-0 mx-3 testSvg'>
                      <FiArrowLeftCircle
                        type='button'
                        onClick={() => {
                          props.setFirstPage(!props.firstPage);
                          props.setToMap && props.setToMap(true);
                        }}
                      />
                    </Col>
                  </OverlayTrigger>
                )}
                <OverlayTrigger
                  placement='top'
                  rootClose='true'
                  trigger={['hover', 'click', 'focus']}
                  overlay={<Tooltip>{t('refresh')}</Tooltip>}
                >
                  <Col xs={1} className='p-0 mx-3 testSvg'>
                    <HiRefresh
                      type='button'
                      className={`${!idri.user_permissions.action && 'disabledCustom'}`}
                      onClick={(e) => {
                        if (idri.user_permissions.action) {
                          idri.wkmode !== 0
                            ? props.getIdri(null, idri.ghatorserial, idri.ghatorid)
                            : props.refresh();
                        }
                      }}
                    />
                  </Col>
                </OverlayTrigger>

                {parseFloat(idri.ghatorv) >= 3 &&
                  props.profiles &&
                  props.profiles.admi &&
                  idri.wkmode === 0 && (
                    <>
                      <OverlayTrigger
                        placement='top'
                        rootClose='true'
                        trigger={['hover', 'click', 'focus']}
                        overlay={<Tooltip>{t('refresh')}</Tooltip>}
                      >
                        <Col xs={1} className='p-0 mx-3 testSvg'>
                          <HiRefresh
                            type='button'
                            color='red'
                            className={`${!idri.user_permissions.action && 'disabledCustom'}`}
                            onClick={(e) => {
                              if (idri.user_permissions.action) {
                                idri.wkmode === 0
                                  ? props.cRefresh()
                                  : props.getIdri(null, idri.ghatorserial, idri.ghatorid);
                              }
                            }}
                          />
                        </Col>
                      </OverlayTrigger>
                    </>
                  )}
                {/* <OverlayTrigger
                  placement='top'
                  rootClose='true'
                  trigger={['hover', 'click', 'focus']}
                  overlay={<Tooltip>{t('info')}</Tooltip>}
                >
                  <Col xs={1} className='p-0 mx-3 testSvg'>
                    <FaInfoCircle type='button' />
                  </Col>
                </OverlayTrigger> */}
                {idri.wkmode !== 0 && (
                  <OverlayTrigger
                    placement='top'
                    rootClose='true'
                    trigger={['hover', 'click', 'focus']}
                    overlay={<Tooltip>{t('editOrders')}</Tooltip>}
                  >
                    <Col xs={1} className='p-0 mx-3 testSvg'>
                      <HiQueueList
                        type='button'
                        onClick={(e) => {
                          setOrdersModal(true);
                        }}
                      />
                    </Col>
                  </OverlayTrigger>
                )}

                <ModalGenerico
                  title={t('editOrders')}
                  onClose={() => {
                    setOrdersModal(false);
                  }}
                  show={ordersModal}
                >
                  <OrdersModal
                    id={idri.ghatorid}
                    serial={idri.ghatorserial}
                    closeModal={() => setOrdersModal(false)}
                  />
                </ModalGenerico>
              </Row>
            </IconContext.Provider>
          </td>
        </tr>
        
        <tr className='border-0'>
          <td className='border-0 p-0'>
            <Row className='gx-0'>
              {(idri.bat_int_value !== null &&
                idri.bat_int_value !== undefined) ||
              (idri.bat_ext_value !== null &&
                idri.bat_ext_value !== undefined) ? (
                <Col xs={12} className='px-1 pb-1 pt-0'>
                  <div className="system-power-panel-wrapper">
                    
                    <div className='system-power-panel'>
                      <div className='system-power-panel__item'>
                        <div className='system-power-panel__watermark'>
                          <SensorVisualIcon visualType='internal_battery' />
                        </div>

                        {parseFloat(idri.ghatorv) >= 3 &&
                          idri.bat_int_alert && (
                            <OverlayTrigger
                              placement='auto'
                              overlay={
                                <Tooltip id='internal-battery-alert'>
                                  <div className='d-flex align-items-center'>
                                    <FiAlertTriangle className='text-danger me-1' />

                                    <div>
                                      <div>{t('alertaDisparada')}</div>

                                      {idri.bat_int_alert_start_date && (
                                        <div>
                                          {t('startDate')}:{' '}
                                          {moment
                                            .utc(idri.bat_int_alert_start_date)
                                            .local()
                                            .format('DD-MM-YYYY, HH:mm:ss')}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Tooltip>
                              }
                            >
                              <button
                                type='button'
                                className='system-power-panel__alert'
                                aria-label={t('alertaDisparada')}
                              >
                                <FiAlertTriangle
                                  size={18}
                                  color='#dc3545'
                                  style={{
                                    display: 'block',
                                    stroke: '#dc3545',
                                    opacity: 1,
                                    visibility: 'visible',
                                  }}
                                />
                              </button>
                            </OverlayTrigger>
                          )}

                        <div className='system-power-panel__content'>
                          <div className='system-power-panel__name'>
                            {t('batIn')}
                          </div>

                          <div className='system-power-panel__reading'>
                            <span className='system-power-panel__value'>
                              {idri.bat_int_value !== null &&
                              idri.bat_int_value !== undefined
                                ? idri.bat_int_value
                                : '—'}
                            </span>

                            <span className='system-power-panel__unit'>V</span>
                          </div>
                        </div>
                      </div>

                      <div className='system-power-panel__item'>
                        <div className='system-power-panel__watermark'>
                          <SensorVisualIcon visualType='external_power' />
                        </div>

                        {parseFloat(idri.ghatorv) >= 3 &&
                          idri.bat_ext_alert && (
                            <OverlayTrigger
                              placement='auto'
                              overlay={
                                <Tooltip id='external-power-alert'>
                                  <div className='d-flex align-items-center'>
                                    <FiAlertTriangle className='text-danger me-1' />

                                    <div>
                                      <div>{t('alertaDisparada')}</div>

                                      {idri.bat_ext_alert_start_date && (
                                        <div>
                                          {t('startDate')}:{' '}
                                          {moment
                                            .utc(idri.bat_ext_alert_start_date)
                                            .local()
                                            .format('DD-MM-YYYY, HH:mm:ss')}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Tooltip>
                              }
                            >
                              <button
                                type='button'
                                className='system-power-panel__alert'
                                aria-label={t('alertaDisparada')}
                              >
                                <FiAlertTriangle
                                  size={18}
                                  color='#dc3545'
                                  style={{
                                    display: 'block',
                                    stroke: '#dc3545',
                                    opacity: 1,
                                    visibility: 'visible',
                                  }}
                                />
                              </button>
                            </OverlayTrigger>
                          )}

                        <div className='system-power-panel__content'>
                          <div className='system-power-panel__name'>
                            {t('batExt')}
                          </div>

                          <div className='system-power-panel__reading'>
                            <span className='system-power-panel__value'>
                              {idri.bat_ext_value !== null &&
                              idri.bat_ext_value !== undefined
                                ? parseFloat(idri.bat_ext_value).toFixed(2)
                                : '—'}
                            </span>

                            <span className='system-power-panel__unit'>V</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>                  
                </Col>
              ) : null}
              </Row>
          </td>
        </tr>

        <tr className='border-0'>
          <td className='border-0 p-0'>
            <div
              style={{
                width: '52%',
                height: '1px',
                backgroundColor: '#b0b0b0',
                margin: '0 auto',
              }}
            />
          </td>
        </tr>

        <tr className='border-0'>
          <td className='border-0 p-0'>           
            <Row className='gx-0'>      
              {idri.sensors?.none_fm_sensors?.map((sensor) => (
                <Col
                  xs={6}
                  md={4}
                  lg={3}
                  xl={2}
                  className='p-1'
                  key={sensor.idsensor}
                >
                  <Card className='sensor-card h-100'>
                    <Card.Body className='sensor-card__body'>
                      <div className='sensor-card__watermark'>
                        <SensorVisualIcon
                          visualType={sensor.sensor_visual_type?.code}
                        />
                      </div>

                      {parseFloat(idri.ghatorv) >= 3 &&
                        sensor.alerts?.state_value_alert &&
                        sensor.alerts_config?.state_value_alert_en && (
                          <OverlayTrigger
                            placement='auto'
                            overlay={
                              <Tooltip id={`sensor-alert-${sensor.idsensor}`}>
                                <div className='d-flex align-items-center'>
                                  <FiAlertTriangle className='text-danger me-1' />

                                  {[1, 2].includes(Number(sensor.kind_sensor?.code))
                                    ? t('umbralMaxMin').toLowerCase()
                                    : t('activEstado').toLowerCase()}
                                </div>
                              </Tooltip>
                            }
                          >
                            <button
                              type='button'
                              className='sensor-card__alert'
                              aria-label={t('alertaDisparada')}
                            >
                              <FiAlertTriangle
                                size={18}
                                color='#dc3545'
                                style={{
                                  display: 'block',
                                  stroke: '#dc3545',
                                  opacity: 1,
                                  visibility: 'visible',
                                }}
                              />
                            </button>
                          </OverlayTrigger>
                        )}

                      <div className='sensor-card__content'>
                        <div className='sensor-card__name'>
                          {sensor.name}
                        </div>

                        <div className='sensor-card__value'>
                          <span>{getSensorDisplayValue(sensor)}</span>
                        </div>

                        {sensor.kind_sensor?.code !== 0 &&
                          sensor.kind_sensor?.code !== 4 &&
                          sensor.magnitude && (
                            <div className='sensor-card__unit'>
                              {sensor.magnitude}
                            </div>
                          )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </td>
        </tr>
        <tr className='border-0'>
          <td className='border-0 p-0'>
            <div
              style={{
                width: '97%',
                height: '1px',
                backgroundColor: '#ea5a0b',
                margin: '0 auto',
              }}
            />
          </td>
        </tr>
        <tr className='border-0'>
          <td className='border-0 p-0'>
            <Row className='gx-0'>
              {idri.sensors?.fm_sensors?.map((sensor) => {
                const hasCounterAlert =
                  parseFloat(idri.ghatorv) >= 3 &&
                  (
                    (sensor.alerts?.leak_alert &&
                      sensor.alerts_config?.leak_en) ||
                    (sensor.alerts?.noflow_alert &&
                      sensor.alerts_config?.noflow_en) ||
                    (sensor.alerts?.cmax_day_alert &&
                      sensor.alerts_config?.cmax_day_en) ||
                    (sensor.alerts?.cmin_day_alert &&
                      sensor.alerts_config?.cmin_day_en) ||
                    (sensor.alerts?.flow_alert &&
                      sensor.alerts_config?.flow_value_en) ||
                    (sensor.alerts?.cmax_month_alert &&
                      sensor.alerts_config?.cmax_month_en)
                  );

                const totalValue =
                  sensor.value !== null && sensor.value !== undefined
                    ? parseFloat(sensor.value).toFixed(
                        scaleDecimal(sensor.scale)
                      )
                    : '0.00';

                const dayValue =
                  sensor.dayconsum !== null &&
                  sensor.dayconsum !== undefined
                    ? parseFloat(sensor.dayconsum).toFixed(
                        scaleDecimal(sensor.scale)
                      )
                    : '0.00';

                const monthValue =
                  sensor.monthconsum !== null &&
                  sensor.monthconsum !== undefined
                    ? parseFloat(sensor.monthconsum).toFixed(
                        scaleDecimal(sensor.scale)
                      )
                    : '0.00';

                const flowValue =
                  sensor.inst_flow !== null &&
                  sensor.inst_flow !== undefined
                    ? sensor.inst_flow
                    : '0.00';

                return (
                  <Col
                    xs={6}
                    md={4}
                    lg={3}
                    xl={2}
                    className='p-1'
                    key={sensor.idsensor}
                  >
                    <Card className='counter-card h-100'>
                      <Card.Body className='counter-card__body'>
                        <div className='counter-card__watermark'>
                          <SensorVisualIcon
                            visualType={
                              sensor.sensor_visual_type?.active !== false
                                ? sensor.sensor_visual_type?.code ||
                                  'counter'
                                : 'counter'
                            }
                          />
                        </div>
                        {hasCounterAlert && (
                          <OverlayTrigger
                            placement='auto'
                            overlay={
                              <Tooltip
                                id={`counter-alert-${sensor.idsensor}`}
                              >
                                {sensor.alerts?.leak_alert &&
                                  sensor.alerts_config?.leak_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('alertFuga')}</span>
                                    </div>
                                  )}

                                {sensor.alerts?.noflow_alert &&
                                  sensor.alerts_config?.noflow_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('noFlujo')}</span>
                                    </div>
                                  )}

                                {sensor.alerts?.cmax_day_alert &&
                                  sensor.alerts_config?.cmax_day_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('consumoMaxD')}</span>
                                    </div>
                                  )}

                                {sensor.alerts?.cmin_day_alert &&
                                  sensor.alerts_config?.cmin_day_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('consumoMinD')}</span>
                                    </div>
                                  )}

                                {sensor.alerts?.flow_alert &&
                                  sensor.alerts_config?.flow_value_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('alertFlujo')}</span>
                                    </div>
                                  )}

                                {sensor.alerts?.cmax_month_alert &&
                                  sensor.alerts_config?.cmax_month_en && (
                                    <div className='counter-alert-tooltip__item'>
                                      <FiAlertTriangle />
                                      <span>{t('consumoMaxM')}</span>
                                    </div>
                                  )}
                              </Tooltip>
                            }
                          >
                            <button
                              type='button'
                              className='counter-card__alert'
                              aria-label={t('alertaDisparada')}
                            >
                              <FiAlertTriangle
                                size={18}
                                color='#dc3545'
                                style={{
                                  display: 'block',
                                  stroke: '#dc3545',
                                  opacity: 1,
                                  visibility: 'visible',
                                }}
                              />
                            </button>
                          </OverlayTrigger>
                        )}

                        <div className='counter-card__content'>
                          <div className='counter-card__name'>
                            {sensor.name}                            
                          </div>

                          <div className='counter-card__total'>
                            <span className='counter-card__total-value'>
                              {totalValue}
                            </span>

                            <span className='counter-card__total-unit'>
                              {sensor.magnitude}
                            </span>
                          </div>

                          <div className='counter-card__line'>
                            <span className='counter-card__label'>
                              {t('hoy')}
                            </span>

                            <span className='counter-card__reading'>
                              {dayValue} {sensor.magnitude}
                            </span>
                          </div>

                          <div className='counter-card__line'>
                            <span className='counter-card__label'>
                              {t('mes')}
                            </span>

                            <span className='counter-card__reading'>
                              {monthValue} {sensor.magnitude}
                            </span>
                          </div>

                          {parseFloat(idri.ghatorv) >= 3 && (
                            <div className='counter-card__line'>
                              <span className='counter-card__label'>
                                {t('caudal')}
                              </span>

                              <span className='counter-card__reading'>
                                {flowValue} {sensor.magnitude}/h
                              </span>
                            </div>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default SensorsControl;
